import React, { Component } from 'react';
import BinIcon from '../assets/icons/bin.svg';
import EditIcon from '../assets/icons/edit.svg';
import Modal from '../CommonComponents/Modal';
import ThemedButtons from '../CommonComponents/ThemedButtons';
import QueueCreation from './QueueCreation';
import { api } from '../utils';
import { QueueInfo } from './model';

type Props = {
  botid: string;
  setInitialQueueName: Function;
  count: number;
  toasterNotification: Function;
  tenantId: number;
};

type State = {
  showDeleteQueueModal: boolean;
  showQueueCreationModal: boolean;
  queueInfo: QueueInfo[];
  queueLength: number;
  shwSelectedQueueName: string;
  needToDeleteQueue: string;
  entityListPerQueueOnHover: any;
  getAgentListPerQueue: any;
  prevAgentData: any;
  entityListLength: number;
  agentListLength: number;
  selectedQueueId: number;
  stepNotification: number;
  isEntityListOnHoverLoading: boolean;
};

export default class QueueData extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.deleteQueue = this.deleteQueue.bind(this);
    this.getQueueList = this.getQueueList.bind(this);
    this.closeQueueCreationModal = this.closeQueueCreationModal.bind(this);
  }

  setInitialState(): State {
    return {
      showDeleteQueueModal: false,
      showQueueCreationModal: false,
      queueInfo: [],
      queueLength: 0,
      shwSelectedQueueName: '',
      needToDeleteQueue: '',
      entityListPerQueueOnHover: [],
      getAgentListPerQueue: [],
      prevAgentData: [],
      entityListLength: 0,
      agentListLength: 0,
      selectedQueueId: 0,
      stepNotification: 1,
      isEntityListOnHoverLoading: false,
    };
  }
  componentDidMount() {
    this.getQueueList();
  }
  entityListonHover(queueId: number) {
    /**
     * Clear the list.
     */
    this.setState({
      entityListPerQueueOnHover: [],
      entityListLength: 0,
      isEntityListOnHoverLoading: true,
    });
    api(
      `getEntityListPerQueue?botId=${encodeURIComponent(
        this.props.botid
      )}&queueId=${queueId}&tenantId=${this.props.tenantId}`,
      'GET'
    ).then((res) => {
      this.setState({
        entityListPerQueueOnHover: res.entityListPerQueueOnHover.slice(0, 5),
        entityListLength: res.entityListPerQueueOnHover.length,
        isEntityListOnHoverLoading: false,
      });
    });
  }
  getAgentListPerQueue(queueId: number) {
    let encodedbotId = encodeURIComponent(this.props.botid);
    api(
      `getAgentListPerQueue?botId=${encodedbotId}&queueId=${queueId}&tenantId=${this.props.tenantId}`,
      'GET'
    ).then((res) => {
      this.setState({
        getAgentListPerQueue: res.agentListPerQueueOnHover.slice(0, 5),
        prevAgentData: res.agentData,
        agentListLength: res.agentListPerQueueOnHover.length,
      });
    });
  }
  getQueueList() {
    let encodedbotId = encodeURIComponent(this.props.botid);
    api(`getQueueList?botId=${encodedbotId}`).then((res) => {
      this.setState({
        queueInfo: res.queueInfo,
        queueLength: res.queueInfo.length,
      });
      this.props.setInitialQueueName(res.defaultQueueName);
    });
  }

  deleteQueue() {
    let data = {
      botId: this.props.botid,
      queueName: this.state.needToDeleteQueue,
    };
    api('deleteQueue', 'POST', data).then((res) => {
      if (res.result === 'success') {
        this.setState({
          showDeleteQueueModal: !this.state.showDeleteQueueModal,
        });
        this.props.toasterNotification('Queue deleted');
        this.getQueueList();
      }
    });
  }
  closeQueueCreationModal() {
    this.setState({
      showQueueCreationModal: false,
      // count: this.state.count + 1,
    });
    this.getQueueList();
  }
  componentDidUpdate(prevPops: Props, _: State) {
    if (this.props.count !== prevPops.count || this.props.botid !== prevPops.botid) {
      this.getQueueList();
    }
  }
  render() {
    return (
      <div className='queue-data'>
        <div className='queue-data-header'>
          <div className='queue-data-header-list'>QUEUE NAME</div>
          <div className='queue-data-header-list'>ENTITIES</div>
          <div
            className='queue-data-header-list'
            style={{ display: 'flex', justifyContent: 'center' }}>
            AGENTS
          </div>
          <div className='queue-data-header-list'></div>
          {/* <div className='queue-data-header-list'></div> */}
        </div>
        <div className='queue-data-content'>
          {this.state.queueInfo.map((data, index) => {
            return (
              <div
                className='queue-data-content-wrapper'
                key={data.queueName + '_' + index}>
                <div
                  className='queue-data-content-data'
                  onClick={() => {
                    this.setState(
                      {
                        showQueueCreationModal: !this.state.showQueueCreationModal,
                        shwSelectedQueueName: data.queueName,
                        selectedQueueId: data.queueId,
                        stepNotification: 1,
                      },
                      () => {
                        this.getAgentListPerQueue(data.queueId);
                      }
                    );
                  }}>
                  {data.queueName}
                </div>
                <div
                  className='queue-data-content-data'
                  onClick={() => {
                    this.setState(
                      {
                        showQueueCreationModal: !this.state.showQueueCreationModal,
                        shwSelectedQueueName: data.queueName,
                        selectedQueueId: data.queueId,
                        stepNotification: 1,
                      },
                      () => {
                        this.getAgentListPerQueue(data.queueId);
                      }
                    );
                  }}>
                  <div
                    id='entity-data'
                    onMouseEnter={() => {
                      this.entityListonHover(data.queueId);
                    }}>
                    {data.entityCount + ' entities'}
                  </div>
                  <div className='entity-hover-data'>
                    {this.state.entityListPerQueueOnHover.length > 0 ? (
                      <ul style={{ margin: '0px', paddingLeft: '14px' }}>
                        {this.state.entityListPerQueueOnHover.map(
                          (val: any, i: number) => {
                            return (
                              <li style={{}} key={i}>
                                {val}
                              </li>
                            );
                          }
                        )}
                      </ul>
                    ) : (
                      <span
                        style={{
                          fontSize: '12px',
                          lineHeight: '1.5',
                          letterSpacing: '-0.18px',
                          color: 'rgba(0,0,0,0.6',
                        }}>
                        {this.state.isEntityListOnHoverLoading
                          ? 'Loading...'
                          : 'No entities added yet'}
                      </span>
                    )}
                    {this.state.entityListLength > 5 && (
                      <span>
                        {'+' + ' '}
                        {this.state.entityListLength - 5}
                        {' ' + 'more'}
                      </span>
                    )}
                  </div>
                </div>
                <div
                  className='queue-data-content-data'
                  style={{ textAlign: 'center' }}
                  onClick={() => {
                    this.setState(
                      {
                        showQueueCreationModal: !this.state.showQueueCreationModal,
                        shwSelectedQueueName: data.queueName,
                        selectedQueueId: data.queueId,
                        stepNotification: 2,
                      },
                      () => {
                        this.getAgentListPerQueue(data.queueId);
                      }
                    );
                  }}>
                  <div
                    id='agent-queue-data'
                    onMouseOver={() => {
                      this.getAgentListPerQueue(data.queueId);
                    }}>
                    {data.agentCount + ' agents'}
                  </div>
                  <div className='agent-hover-data' style={{ textAlign: 'initial' }}>
                    {this.state.getAgentListPerQueue.length > 0 ? (
                      <ul style={{ margin: '0px', paddingLeft: '14px' }}>
                        {this.state.getAgentListPerQueue.map((val: any, i: number) => {
                          return (
                            <li style={{}} key={i}>
                              <span style={{ textTransform: 'capitalize' }}>{val}</span>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <span
                        style={{
                          fontSize: '12px',
                          lineHeight: '1.5',
                          letterSpacing: '-0.18px',
                          color: 'rgba(0,0,0,0.6',
                        }}>
                        No agents added yet
                      </span>
                    )}
                    {this.state.agentListLength > 5 && (
                      <span style={{ marginLeft: '17px' }}>
                        {'+' + ' '}
                        {this.state.agentListLength - 5}
                        {' ' + 'more'}
                      </span>
                    )}
                  </div>
                </div>
                <div className='queue-data-content-data'>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                    }}>
                    <img
                      src={EditIcon}
                      alt='edit'
                      onClick={() => {
                        this.setState(
                          {
                            showQueueCreationModal: !this.state.showQueueCreationModal,
                            stepNotification: 1,
                            shwSelectedQueueName: data.queueName,
                            selectedQueueId: data.queueId,
                          },
                          () => {
                            this.getAgentListPerQueue(data.queueId);
                          }
                        );
                      }}
                      style={
                        data.queueName === 'Default'
                          ? { marginRight: '35px' }
                          : { marginRight: '15px' }
                      }
                      // style={data.queueName === 'Default' ? { marginRight: '20px' } : {}}
                    />
                    {data.queueName !== 'Default' ? (
                      <div
                        className='queue-data-content-data'
                        style={{ borderBottom: 'none' }}>
                        <img
                          src={BinIcon}
                          alt='delete'
                          onClick={() => {
                            this.setState({
                              showQueueCreationModal: false,
                              showDeleteQueueModal: true,
                              needToDeleteQueue: data.queueName,
                            });
                          }}
                          style={{ display: 'flex' }}
                        />
                      </div>
                    ) : (
                      <div
                        className='queue-data-content-data'
                        style={{ borderBottom: 'none' }}></div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
          {/* changed */}
          {this.state.showDeleteQueueModal ? (
            <Modal
              isOpen={this.state.showDeleteQueueModal}
              title='Delete queue'
              onClose={() => {
                this.setState({
                  showDeleteQueueModal: !this.state.showDeleteQueueModal,
                });
              }}>
              <div>
                <div style={{ fontSize: '14px', lineHeight: '1.57' }}>
                  Please confirm, delete the queue called{' '}
                  <span style={{ fontWeight: 'bolder' }}>
                    {this.state.needToDeleteQueue}
                  </span>
                  ? Any entities in the queue will move to the Default queue
                </div>
                <div className='delete-queue-wrapper'>
                  <div style={{ marginRight: '10px' }}>
                    <ThemedButtons
                      title='Cancel'
                      theme='1'
                      onClick={() => {
                        this.setState({
                          showDeleteQueueModal: !this.state.showDeleteQueueModal,
                        });
                      }}
                    />
                  </div>
                  <ThemedButtons title='Delete' theme='5' onClick={this.deleteQueue} />
                </div>
              </div>
            </Modal>
          ) : null}
          {/* changed */}
          {this.state.showQueueCreationModal ? (
            <Modal
              isOpen={this.state.showQueueCreationModal}
              title={this.state.shwSelectedQueueName}
              onClose={() => {
                this.setState({
                  showQueueCreationModal: !this.state.showQueueCreationModal,
                });
              }}
              source='queue-creation'
              handleClick={() => {}}
              onFocusFieldChange={(shwSelectedQueueName) =>
                this.setState({ shwSelectedQueueName })
              }>
              <QueueCreation
                selectedBotId={this.props.botid}
                title={this.state.shwSelectedQueueName}
                closeCreateQueue={this.closeQueueCreationModal}
                notification={this.props.toasterNotification}
                action={this.state.showQueueCreationModal ? 'edit' : ''}
                prevAgentData={this.state.prevAgentData}
                selectedQueueId={this.state.selectedQueueId}
                queueName={this.state.shwSelectedQueueName}
                stepNotification={this.state.stepNotification}
                entityListLength={this.state.entityListLength}
                tenantId={this.props.tenantId}
              />
            </Modal>
          ) : null}
        </div>
      </div>
    );
  }
}
